import { render } from "./ActivityContent.vue?vue&type=template&id=d5e0137a"
import script from "./ActivityContent.vue?vue&type=script&lang=js"
export * from "./ActivityContent.vue?vue&type=script&lang=js"
script.render = render

export default script